import {Directive, ElementRef, forwardRef, Input, OnInit, Renderer2} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {fromEvent, merge, Subscription, timer} from 'rxjs';
import {debounce, filter, map} from 'rxjs/operators';

export const DEFAULT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => NgControlOptionsDirective),
  multi: true
};

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'input[ngControlOptions]',
  providers: [DEFAULT_VALUE_ACCESSOR]
})
export class NgControlOptionsDirective implements ControlValueAccessor, OnInit {
  onChange;
  onTouched;

  private _controlOptions = {
    updateOn: 'input',
    debounce: null
  };
  private events: Subscription;

  @Input() set ngControlOptions(val) {
    this._controlOptions = {...this._controlOptions, ...val};
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  constructor(private renderer: Renderer2, private element: ElementRef) {
  }

  ngOnInit() {
    const events = this._controlOptions.updateOn.split(' ') // ['input', 'blur']
      .map(event => fromEvent(this.element.nativeElement, event));

    this.events = merge(...events)
      .pipe(
        map((e: Event) => ({input: e.target as HTMLInputElement, type: e.type, value: e.target['value']})),
        filter(value => !value.input.disabled && !value.input.readOnly),
        debounce(event => {
        const debounceValue = this._controlOptions.debounce;
        let time = 0;
        if (typeof debounceValue === 'number') {
          time = debounceValue;
        } else if (typeof debounceValue === 'object') {
          time = debounceValue[event.type] ? debounceValue[event.type] : 0;
        }
        return timer(time);
      }))
      .subscribe(event => {
        this.onChange(event.value);
      });
  }

  writeValue(value: any): void {
    const normalizedValue = value == null ? '' : value;
    this.renderer.setProperty(this.element.nativeElement, 'value', normalizedValue);
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.element.nativeElement, 'disabled', isDisabled);
  }
  ngOnDestroy() {
    this.events.unsubscribe();
  }
}
